export const FIREBASE_AUTH_NETWORK_REQUEST_FAILED = "auth/network-request-failed";

export const isFirebaseAuthNetworkRequestFailed = (error: unknown): boolean => {
  const normalizedError = error as { code?: unknown; message?: unknown } | null | undefined;
  const code = typeof normalizedError?.code === "string" ? normalizedError.code : "";
  const message = typeof normalizedError?.message === "string" ? normalizedError.message : "";

  return (
    code === FIREBASE_AUTH_NETWORK_REQUEST_FAILED ||
    message.includes(FIREBASE_AUTH_NETWORK_REQUEST_FAILED)
  );
};
